import { Money, formatMoney } from '@betterment/js-runtime';

import { PayrollContributionRate } from '~/graphql/schema';

export function percentToString(value: number) {
  return value.toFixed(1);
}

export function amountToString(value: Money) {
  return formatMoney(value).replace(/^(-)?\$/, '$1');
}

export function payrollContributionRateToString(rate: PayrollContributionRate) {
  switch (rate.__typename) {
    case 'PayrollContributionPercent':
      return percentToString(rate.percent);
    case 'PayrollContributionAmount':
      return amountToString(rate.amount);
    default:
      throw TypeError('Unexpected type name on union type.');
  }
}
